import { Image } from '$components/basic/Image';
import { Banner } from '../styled';
import type { PartnerDataProps } from '../types';
import { PartnerText } from './PartnerText';

export function PartnerBanner({
  pathname,
  partnerData,
}: {
  pathname: string;
  partnerData?: PartnerDataProps;
}) {
  return (
    <Banner className="partner-banner">
      <Image
        className="discount"
        provider="cloudinary"
        src="/icons/Icon_discount_quotes_ynqckm.svg"
        alt="discount"
        layout="fixed"
        width="25"
        height="26"
      />
      <PartnerText pathname={pathname} data={partnerData} />
    </Banner>
  );
}
